import type { CombatState, EnemyAction } from './types';

/**
 * IA enemiga.
 *
 * Perfil rule-based con evaluación de utilidad:
 *  - Si HP enemigo < umbralDefensivo y no está en ronda bloqueada del especial,
 *    chance alta de defender.
 *  - Si HP del player ≤ 30% y el enemigo tiene especial disponible → usarlo (ir por el kill).
 *  - Si el enemigo tiene especial listo y se siente confiado (HP >= 50%),
 *    usarlo con probabilidad ai.agresividadOportunista.
 *  - Si no, atacar normal.
 *
 * El objetivo es que el enemigo "haga su mejor esfuerzo" — que no desperdicie
 * especiales ni defienda cuando no tiene que.
 */
export function decidirAccionEnemigo(
  state: CombatState,
  rng: () => number,
): EnemyAction {
  const { enemy, player, ronda } = state;

  const ratioEnemy = enemy.vidaActual / enemy.vida;
  const ratioPlayer = player.vida / player.vidaMax;
  const especialListo =
    enemy.ai.especial !== undefined && ronda >= enemy.especialDisponibleEn;

  // 1. Kill shot — si el player está al borde y el especial está listo,
  //    priorizar especial para cerrar.
  if (especialListo && ratioPlayer <= 0.3) {
    return { kind: 'especial' };
  }

  // 2. Si está bajo de vida, chance de defender (pero no siempre, para
  //    no hacer combates aburridos).
  if (ratioEnemy <= enemy.ai.umbralDefensivo && rng() < 0.55) {
    return { kind: 'defender' };
  }

  // 3. Oportunidad de especial cuando se siente cómodo.
  if (especialListo && ratioEnemy >= 0.5 && rng() < enemy.ai.agresividadOportunista) {
    return { kind: 'especial' };
  }

  // 4. Default: atacar.
  return { kind: 'atacar' };
}
